import { z } from "zod"

/** YYYY-MM-DD completion date stored on the primary work-scope row. */
export const completionDateSchema = z.union([
  z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Enter a valid date"),
  z.literal(""),
  z.null(),
]).optional()
